// @flow
import { get } from 'lodash';
import { type FieldProps, type FormikContextType } from 'formik';

import { IS_INVALID, IS_VALID } from 'Components/frameworks/form-validator-hoc/validationStates';
import * as yup from 'yup';

export const getValidationStatus = (
  { name, value }: $PropertyType<FieldProps, 'field'>,
  { touched, errors, submitCount }: $PropertyType<FieldProps, 'form'>,
  isDisabled?: boolean = false,
) => {
  const hadInteraction = get(touched, name) || submitCount > 0;
  const validationState = get(errors, name) ? IS_INVALID : IS_VALID;
  const isValidated = hadInteraction && validationState === IS_VALID && value;
  const isErrored = hadInteraction && validationState === IS_INVALID;

  return {
    isDefaultState: !isValidated && !isErrored && !isDisabled,
    isErrored,
    isTouched: hadInteraction,
    isValidated,
  };
};

export const getValidateFieldFunction = (validator: yup, context: ?FormikContextType) => async (
  val: string,
) => {
  let validationResult = '';
  try {
    await validator.validateSync(val, { context });
  } catch (e) {
    validationResult = e.message;
  }
  return validationResult;
};

export const focusNextInput = (target: HTMLInputElement) => {
  const nextRef = target.nextSibling;

  if (target.value.length === target.maxLength && nextRef) {
    nextRef.focus();
  }
};
